import { render } from "./ModalWindow.vue?vue&type=template&id=e858c344&scoped=true"
import script from "./ModalWindow.vue?vue&type=script&lang=js"
export * from "./ModalWindow.vue?vue&type=script&lang=js"

import "./ModalWindow.vue?vue&type=style&index=0&id=e858c344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e858c344"]])

export default __exports__